<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong>系统日志</strong>
        <div class="float-right d-flex align-items-center">
          <CSelect
            v-model="filterModule"
            :options="moduleOptions"
            placeholder="全部模块"
            style="width: 150px"
            @change="onFilterChange"
          />
          <CSelect
            v-model="filterStatus"
            :options="statusOptions"
            placeholder="全部状态"
            class="ml-2"
            style="width: 120px"
            @change="onFilterChange"
          />
          <CInput
            v-model="filterRouterId"
            placeholder="路由器 ID"
            class="ml-2"
            style="width: 120px"
            @keyup.enter="onFilterChange"
          />
          <CButton color="primary" size="sm" class="ml-2" @click="onFilterChange">查询</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <CDataTable
          :items="logList"
          :fields="fields"
          hover
          striped
          :loading="loading"
        >
          <template #module="{ item }">
            <td>
              <CBadge :color="moduleColor(item.module)">{{ moduleLabel(item.module) }}</CBadge>
            </td>
          </template>
          <template #status="{ item }">
            <td>
              <CBadge :color="item.status === 'success' ? 'success' : 'danger'">
                {{ item.status }}
              </CBadge>
            </td>
          </template>
          <template #created_at="{ item }">
            <td>{{ item.created_at | dateFormat }}</td>
          </template>
          <template #message="{ item }">
            <td>
              <small v-if="item.message" class="text-muted">{{ item.message }}</small>
              <span v-else class="text-muted">-</span>
            </td>
          </template>
        </CDataTable>

        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="text-muted small">
            共 {{ total }} 条，第 {{ page }} / {{ totalPages }} 页
            <CSelect
              v-model="perPage"
              :options="perPageOptions"
              size="sm"
              style="width: 80px; display: inline-block; margin-left: 10px;"
              @change="onFilterChange"
            />
          </div>
          <CPagination
            :activePage="page"
            :pages="totalPages"
            @update:activePage="onPageChange"
          />
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'SystemLogs',
  data() {
    return {
      loading: false,
      logList: [],
      total: 0,
      page: 1,
      perPage: 50,
      perPageOptions: [
        { value: 20, label: '20/页' },
        { value: 50, label: '50/页' },
        { value: 100, label: '100/页' },
        { value: 200, label: '200/页' }
      ],
      filterModule: '',
      filterStatus: '',
      filterRouterId: '',
      fields: [
        { key: 'id', label: '#', _style: 'width:60px' },
        { key: 'created_at', label: '时间', _style: 'width:160px' },
        { key: 'module', label: '模块', _style: 'width:100px' },
        { key: 'router_name', label: '路由器', _style: 'width:200px' },
        { key: 'ref_name', label: '关联', _style: 'width:200px' },
        { key: 'action', label: '操作', _style: 'width:100px' },
        { key: 'status', label: '状态', _style: 'width:80px' },
        { key: 'duration_ms', label: '耗时(ms)', _style: 'width:90px' },
        { key: 'message', label: '消息' }
      ],
      moduleOptions: [
        { value: '', label: '全部模块' },
        { value: 'backup', label: '备份' },
        { value: 'filter_sync', label: 'Filter 同步' },
        { value: 'routing_rule', label: '策略路由' }
      ],
      statusOptions: [
        { value: '', label: '全部状态' },
        { value: 'success', label: '成功' },
        { value: 'failed', label: '失败' }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.perPage))
    }
  },
  mounted() {
    this.loadLogs()
  },
  methods: {
    onFilterChange() {
      this.page = 1
      this.loadLogs()
    },
    onPageChange(p) {
      this.page = p
      this.loadLogs()
    },
    async loadLogs() {
      this.loading = true
      try {
        const params = { limit: this.perPage, page: this.page }
        if (this.filterModule) params.module = this.filterModule
        if (this.filterStatus) params.status = this.filterStatus
        if (this.filterRouterId) params.router_id = this.filterRouterId
        const res = await this.$axios.get('user/logs', { params })
        if (res.data.code === 200) {
          this.logList = res.data.data
          this.total = res.data.total || 0
        }
      } catch (e) {
        this.$toasted.show('网络错误: ' + e.message, { type: 'error' })
      }
      this.loading = false
    },
    moduleLabel(m) {
      const map = { backup: '备份', filter_sync: 'Filter同步', routing_rule: '策略路由' }
      return map[m] || m
    },
    moduleColor(m) {
      const map = { backup: 'info', filter_sync: 'primary', routing_rule: 'warning' }
      return map[m] || 'secondary'
    }
  }
}
</script>
